import React, { useState } from 'react';
import { Select, Skeleton } from 'antd';
import { ICONS } from 'assets/icons';
import Duplicate from 'assets/customSVG/Duplicate';
import Check from 'assets/customSVG/Check';
import { baseURL } from '../../api/ApiConfig';

const WhatsAppNumberSelect = ({
  numbers,
  selectedNumber,
  onSelect,
  loading = false,
}) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (loading) {
    return <Skeleton.Input active className="min-w-[20vw]" />;
  }

  if (numbers.length === 0) {
    return (
      <div className="text-gray-500">No WhatsApp business numbers found</div>
    );
  }

  return (
    <div className="w-full h-full">
      <div className="relative w-full">
        <Select
          className="w-full h-auto"
          value={selectedNumber?.id}
          onChange={(value) => {
            const selected = numbers.find((n) => n.id === value);
            onSelect(selected);
          }}
          placeholder="Select a number"
          suffixIcon={
            <img
              src={ICONS.chevronDownCarousel}
              alt="dropdown"
              className="w-4 h-4"
            />
          }
          dropdownStyle={{
            minWidth: '300px',
            borderRadius: '0.5rem',
            boxShadow:
              '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          }}
          dropdownRender={(menu) => (
            <div className="bg-white rounded-md">{menu}</div>
          )}
          optionLabelProp="label"
        >
          {numbers.map((num) => {
            const optionContent = (
              <div className="py-1">
                <div className="font-medium">{num.send_from_phone_name}</div>
                <div className="text-gray-500 text-sm">
                  +{num.country_code}
                  {num.send_from_phone_number}
                </div>
              </div>
            );

            return (
              <Select.Option
                key={num.id}
                value={num.id}
                label={optionContent}
                className={`${
                  selectedNumber?.id === num.id ? 'bg-blue-50' : ''
                } hover:bg-blue-50 transition-colors`}
              >
                <div className="py-1 flex items-center justify-between">
                  <div>
                    <div className="font-medium">
                      {num.send_from_phone_name}
                    </div>
                    <div className="text-gray-500 text-sm">
                      +{num.country_code}
                      {num.send_from_phone_number}
                    </div>
                  </div>
                  {selectedNumber?.id === num.id && (
                    <div className="ml-4 text-blue-600">
                      <Check width={16} height={16} />
                    </div>
                  )}
                </div>
              </Select.Option>
            );
          })}
        </Select>
      </div>

      {selectedNumber && (
        <div className="mt-1.5 py-2 px-3 bg-gray-50 rounded-md border border-gray-100">
          <div className="text-[11px] font-medium text-[var(--font-600)] uppercase tracking-wider mb-1">
            WhatsApp Link:
          </div>
          <div className="flex justify-between items-center">
            <div>
              <div className="text-blue-600 text-sm break-all">
                <a
                  href={`${baseURL}wa/${selectedNumber.country_code}${selectedNumber.send_from_phone_number}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  {baseURL}wa/{selectedNumber.country_code}
                  {selectedNumber.send_from_phone_number}
                </a>
              </div>
            </div>
            <button
              onClick={() =>
                copyToClipboard(
                  `${baseURL}wa/${selectedNumber.country_code}${selectedNumber.send_from_phone_number}`,
                )
              }
              className="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-200 transition-colors"
              title="Copy link"
            >
              <Duplicate
                width={16}
                height={16}
                color={copied ? '#4F46E5' : '#6B7280'}
              />
            </button>
          </div>
          {copied && (
            <div className="text-xs text-green-600 mt-1">
              Copied to clipboard!
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default WhatsAppNumberSelect;
